<template>
    <div>
        <fieldset v-if="Object.keys(topics).length > 0">
            <h3>Update Your Contact Information</h3>
            <div class="field">
                <input class="input" required type="email" placeholder="Email" v-model="email" :name="'subscription_form[email]'">
                <input type="hidden" v-model="lastEmail" :name="'subscription_form[last_email]'">
            </div>
            <div class="field">
                <input class="input" type="text" placeholder="New Email" :name="'subscription_form[new_email]'">
            </div>
            <p><small>Will be used in accordance with our <a href="/privacy-policy">Privacy Policy</a>.</small></p>
            <p v-show="error" class="help u-text-red">Uh oh! Something went wrong. Please try again.</p>
            <h3>Select Your Newsletters</h3>
            <div class="topics-list">
                <button class="button" type="button" @click="setAllTopics(true)">Subscribe to All</button>
                <div class="field" v-for="topic in topics" :key="topic.code">
                    <div class="control">
                        <input type="checkbox" :name="'subscription_form[topics][' + topic.code + ']'" :id="topic.code" v-model="topic.checked" @change="topic.checked = !topic.checked">
                        <label :for="topic.code" v-html="topic.label">
                        </label>
                    </div>
                </div>
                <button class="button" type="button" @click="setAllTopics(false)">Unsubscribe from all</button>
            </div>
            <div class="control">
                <button class="button" :class="{'button--loading': loading}">Submit</button>
            </div>
        </fieldset>
        <div v-else class="alert-danger">
            There was a problem retrieving your information. Please try again later.
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                error: false,
                lastEmail: this.email
            };
        },
        props: {
            email: String,
            input_class: {
                type: String,
                default: 'control'
            },
            topics: {
                type: Array,
                default() {
                    return [];
                }
            }
        },
        methods: {
            setAllTopics(subscribe) {
                Object.keys(this.topics).forEach(key => this.topics[key].checked = subscribe);
                this.$forceUpdate();
            }
        }
    };
</script>
